<prlw-all-table-column-header-ui
  [column]="column"
  [sorting]="sorting$ | async"
></prlw-all-table-column-header-ui>
